import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AgentContextEntryPoint as main } from '@jira/spa-apps__space-agent-context/src/agentContext.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { softwareAgentContextClassicRoute } from '@jira/router-routes__software-agent-context-classic-routes/src/softwareAgentContextClassicRoute.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';

const softwareAgentContextClassicEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main,
		horizontalNavigation: jiraHorizontalNavEntrypoint,
	});

export const softwareAgentContextClassicRouteEntry: Route = createEntry(
	softwareAgentContextClassicRoute,
	() => ({
		group: 'classic-software',
		perfMetricKey: 'software.agent-context-classic',
		layout: classicSoftwareProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		entryPoint() {
			return expValEquals('jira-agent-context-experiment', 'isEnabled', true, false)
				? softwareAgentContextClassicEntryPoint
				: notFoundPageEntrypoint;
		},

		resources: [
			...getNavigationResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			projectThemeResource,
		],
		forPaint: [LazyAtlassianNavigation],
		ufoName: 'software-agent-context-classic',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		supportsProjectTheme: 'full',
	}),
);
